<template>
  <div class="mainBody" v-loading="loading">
     <div class="header">电子面单</div>
     <div class="bindList" v-if="(bindType == 99 || bindType == 4) && !addnet">
        <div class="addTips">您尚未添加电子面单账号，可通过以下方式添加：</div>
        <div class="bindItem">
            <h4>方式一：绑定协议快递员</h4>
            <div class="color8">通过与快递员建立绑定关系，获取单号授权，打单时消耗快递员的单号</div>
            <div><el-button type="primary" size="small" @click="bindKdy">绑定协议快递员</el-button></div>
        </div>
        <div class="bindItem">
            <h4>方式二：添加网点面单</h4>
            <div class="color8">通过合作网点提供的电子面单账号，获取单号授权，打单时消耗该账号的单号</div>
            <div><el-button type="primary" size="small" @click="addnet = true">添加网点面单</el-button></div>
        </div>
     </div>
     
     <div class="addnet" v-if="(bindType == 99 || bindType == 4) && addnet">
        <el-form label-position="left" label-width="80px" :model="addnetForm" size="small" :rules="rules" ref="ruleForm">
        <el-form-item label="快递公司" prop="company">
            <el-input v-model="addnetForm.company" disabled></el-input>
        </el-form-item>
        <el-form-item label="面单账号" prop="mail_user_name">
            <el-input v-model="addnetForm.mail_user_name" placeholder="请输入合作网点提供的面单账号"></el-input>
        </el-form-item>
        <el-form-item label="账号密码" prop="mail_pass_word">
            <el-input v-model="addnetForm.mail_pass_word" placeholder="请输入面单账号的密码" show-password prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm" style="width:200px">保  存</el-button>
        </el-form-item>
        </el-form>
     </div>

     <div class="netInfo" v-if="bindType == 10 || bindType == 12 ">
        <el-row class="rowstyle">
          <el-col :span="24"><div>网点面单</div></el-col>
        </el-row>
        <el-row class="rowstyle">
          <el-col :span="5"><div>快递公司</div></el-col>
          <el-col :span="15"><div>{{netzhInfo.company}}</div></el-col>
          <el-col :span="4"><div><el-button type="danger" plain size="mini" @click="delFun" v-show="delbtnShow">删除</el-button></div></el-col>
        </el-row>
        <el-row class="rowstyle">
          <el-col :span="5"><div>面单账号</div></el-col>
          <el-col :span="19"><div>{{netzhInfo.mail_user_name}}</div></el-col>
        </el-row>
        <el-row class="rowstyle">
          <el-col :span="5"><div>面单余量</div></el-col>
          <el-col :span="19"><div>{{netzhInfo.mail_balance}}</div></el-col>
        </el-row>
     </div>

     <div class="netInfo" v-if="bindType == 1 || bindType == 0">
        <el-row class="rowstyle">
          <el-col :span="24"><div>协议面单 <span v-if="ywyInfo.auth_type === 0" class="color_warning">(待审核)</span></div></el-col>
        </el-row>
        <el-row class="rowstyle">
          <el-col :span="5"><div>协议快递员</div></el-col>
          <el-col :span="15"><div>{{ywyInfo.ywy_name}}</div></el-col>
          <el-col :span="4"><div><el-button type="danger" plain size="mini" @click="delFun" v-show="delbtnShow">删除</el-button></div></el-col>
        </el-row>
        <el-row class="rowstyle">
          <el-col :span="5"><div>联系方式</div></el-col>
          <el-col :span="19"><div>{{ywyInfo.ywy_phone}}</div></el-col>
        </el-row>
        <el-row class="rowstyle">
          <el-col :span="5"><div>所属网点</div></el-col>
          <el-col :span="19"><div>{{ywyInfo.branch_name}}</div></el-col>
        </el-row>
     </div>
  </div>
</template>
<script>
import home from "@/api/home";
import bindKdy  from '@/api/bindKdy';
import team from "@/api/team";
import util from '@/util/util';
import  teamMix  from '@/mixin/teamMix';
export default {
    name:"electronBill",
    mixins: [teamMix],
    data(){
        return{
            addnetForm:{
              company:'韵达快递',
              mail_user_name:'',
              mail_pass_word:'',
            },
            rules:{
              mail_user_name:[{ required: true, message: '请输入网点面单账号', trigger: 'blur' }], 
              mail_pass_word:[{ required: true, message: '请输入网点面单密码', trigger: 'blur' }]
            },
            netzhInfo:{
              mail_user_name:'',
              mail_balance:'',
              company:'',
            },
            ywyInfo:{
              ywy_name:'',
              ywy_phone:'',
              branch_name:'',
              auth_type:99,
            },
            bindType:99,
            loading:true,
            addnet:false,
            delbtnShow:true,
        }
    },
    mounted(){
     this.loadData(); 
    },
    methods:{
      //固定加载函数
      loadData(){
        this.hasbind();
        this.getRole();
      },
      //获取角色信息
      getRole(){
        team.pretReatment(this).then(res=>{
          if(res.success){
            const type = res.data;
            if(type == 2 && this.$store.state.teamModel == 2){this.delbtnShow=false}else{this.delbtnShow=true}
          }
        })
      },
      //判断绑定关系
      hasbind(){
        home.hasbind(this).then((res) => {
          if(res.success){
            this.bindType = res.data;
            if([0,1].includes(this.bindType)){
              this.getywyInfo();
              this.$store.commit("SET_BIND_KDY",this.bindType);
            }else if(this.bindType == 10 || this.bindType == 12){ 
              this.getnetInfo();
              this.$store.commit("SET_BIND_KDY",this.bindType); 
            }else{
              this.addnet = false;
            }
            this.loading = false 
          }
        });
      },
      bindKdy(){
        this.$router.push({path:'./bindywy'})
      },
      submitForm(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.addnetInfo();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //删除电子面单账号
      delFun(){
        this.$confirm('是否确认删除该面单账号？删除后，将无法继续使用其单号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
            const query = {
              account_id:util.getCookie("account_id"), 
              mail_type:(this.bindType == 10 || this.bindType == 12)? 1 : 0
            }
            bindKdy.delMailauth(this,query).then(res=>{
                if(res.success){
                  this.hasbind()
                  this.$message.success('删除成功')
                }
            })
          }).catch(() => {});
      },
      //获取网点账号
      getnetInfo(){
        const query = {
          account_id:util.getCookie("account_id") 
        }
        bindKdy.lookMailinfo(this,query).then(res=>{
            if(res.success){
              const {mail_user_name,mail_balance,company} = res.data 
              this.netzhInfo.mail_user_name = mail_user_name;
              this.netzhInfo.mail_balance = mail_balance;
              this.netzhInfo.company = company;
            }
        })
      },
      //获取业务员信息
      getywyInfo(){
        const query = {
          account_id:util.getCookie("account_id") 
        }
        bindKdy.queryMailAuthInfo(this,query).then(res=>{
            if(res.success){
              const {ywy_name,ywy_phone,branch_name,auth_type} = res.data 
              this.ywyInfo.ywy_name = ywy_name;
              this.ywyInfo.ywy_phone = ywy_phone;
              this.ywyInfo.branch_name = branch_name;
              this.ywyInfo.auth_type = auth_type;
            }
        })
      },
      //添加网点账号信息
      addnetInfo(){
        const obj = {
          account_id:util.getCookie("account_id"), 
        }
        let query = Object.assign(obj,this.addnetForm)
        bindKdy.bindsItemail(this,query).then(res=>{
            if(res.success){
              this.hasbind()
              this.$message.success('添加成功')
            }
        })
      }
    }
}
</script>
<style lang="stylus" scoped>
.mainBody{
    padding 10px 30px
}
.header{
    font-size 16px;
    font-weight bold
    border-bottom  1px solid #DCDFE6
    line-height 50px
    color #2ea2fc
}
.addTips{
    padding-left: 40px;
    margin-top: 20px;
    font-size: 14px;
    color #E6A23C;
}
.color_warning{
   color #E6A23C;  
}
.bindItem{
    padding: 0 40px;
    line-height:30px;
    margin-top: 20px;
}   
.color8{
    color: #888888;
    font-size: 12px;
    margin-bottom: 10px;
}
.addnet,.netInfo{
    width: 450px;
    padding-left: 40px;
    padding-top: 20px;
}
.rowstyle{
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    border-bottom: 1px solid #dcdfe6;
}
</style>